import type { ApiStorageStockEntry } from '@Model';

export type StockView = 'material' | 'avv';

export const NO_AVV_LABEL = 'ohne AVV';

export interface StockRow {
    id: string;
    label: string;
    quantity: number;
}

export interface GroupedStock {
    rows: StockRow[];
    total: number;
}

const isZero = (quantity: number) => Math.abs(quantity) < 0.0005;

function rowOf({ material, avv }: ApiStorageStockEntry, view: StockView): Omit<StockRow, 'quantity'> {
    if (view === 'material') {
        return { id: material.foreign_key ?? '', label: material.display_string };
    }
    return { id: avv.foreign_key ?? '', label: avv.foreign_key ? avv.display_string : NO_AVV_LABEL };
}

/** The stock lines summed per material or per AVV, without the lines that are zero, and the total over all lines. */
// @ai-generated 2026-10-23T13:30:00+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function groupStorageStock(entries: ApiStorageStockEntry[], view: StockView): GroupedStock {
    const rows = new Map<string, StockRow>();
    for (const entry of entries) {
        const row = rowOf(entry, view);
        const known = rows.get(row.id);
        if (known) {
            known.quantity += entry.quantity;
        } else {
            rows.set(row.id, { ...row, quantity: entry.quantity });
        }
    }

    const total = entries.reduce((sum, entry) => sum + entry.quantity, 0);
    return {
        rows: [...rows.values()].filter((row) => !isZero(row.quantity)),
        total: isZero(total) ? 0 : total,
    };
}
